import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default function ModalDeleteFermeture(props) {
  const { t } = useTranslation();
  const [styleFadeIn, setFadeIn] = useState(true);

  const closeModaleCancel = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.handleCloseFermeture();
    }, 400);
  }, []);
  return (
    <StyleRoot>
      <div
        class="modal show modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalConfirm"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                props.onSubmitSuppression();
              }}
            >
              <button
                onClick={closeModaleCancel}
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close src="img/close.svg" class="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section>
                  <h5 className="modal-title">{t('creche.delete_closure_title')}</h5>
                </section>
                <section>
                  <h5>{t('creche.delete_closure_confirm')}</h5>
                </section>
                <p className="bottom-space"></p>
                <section>
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className="btn-gradient btn-valid margin-left col-md-6 col-lg-6"
                      style={{ background: "grey", float: "right" }}
                    >
                      {" "}
                      {t('common.delete')}
                    </button>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
